import { jsonArrayMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminValidationSettingsResponse {
  @jsonArrayMember(String)
  public readonly nipBlackList!: string[];
}
